import React, { Fragment } from 'react'
import cta, { defaultCta, helpLink } from './cta'
import { ellevestMarketingSite } from 'utils/links'


const somethingDidntWork = 'Oops — something didn’t work right.'

const unsupportedBrowserError = {
  heading: 'Oh no! This browser isn’t supported.',
  copy: `Ellevest Private Wealth is optimized for Google Chrome, Apple Safari, and Mozilla Firefox.
  For the best experience, we recommend using the latest version of one of those browsers.`,
  cta: () => cta('Go to Ellevest', ellevestMarketingSite)
}
const techGlitch = 'We’re experiencing a tech glitch right now.'

const onboarding = {
  serverError: {
    heading: somethingDidntWork,
    copy: `To get back to the form, click the button below to try again or use the link that was sent to you via email.`,
    cta: previousPath => cta('Try Again', previousPath)
  },
  idleSessionTimeout: {
    heading: 'Oops — looks like you were timed out.',
    copy: `To get back to the form, please use the link that was sent to you via email.`,
    cta: () => defaultCta()
  },
  missingOnboardingToken: {
    heading: somethingDidntWork,
    copy: `To get back to the form, please use the link that was sent to you via email.`,
    cta: () => defaultCta()
  }
}

const client = {
  serverError: {
    heading: somethingDidntWork,
    copy: (
      <Fragment>
        Click the button below to try again. If you still have questions,
        please {helpLink()} and we’ll help.
      </Fragment>
    ),
    cta: () => cta('Back to Overview', '/dashboard')
  },
  unsupportedBrowser: unsupportedBrowserError,
  technicalGlitchError: {
    heading: techGlitch,
    copy: (
      <Fragment>
        We’re working on resolving the issue. If you need to access your documents,
        {helpLink(' contact your team')} and we’ll be happy to help.
      </Fragment>
    ),
    cta: () => cta('Contact Team', 'mailto:pwm@ellevest.com')
  }
}

const prospect = {
  serverError: {
    heading: somethingDidntWork,
    copy: (
      <Fragment>
        Click the button below to try again. If you still have questions,
        please {helpLink()} and we’ll help.
      </Fragment>
    ),
    cta: () => cta('Back to Documents', '/documents/my-uploads')
  },
}

const general = {
  unsupportedBrowser: unsupportedBrowserError
}

const defaultError = {
  heading: 'Oops — we couldn’t find the page you’re looking for.',
  copy: `Looks like this URL isn’t working. Check to see you have the correct link and try again or contact our support team.`,
  cta: () => defaultCta()
}

const errors = {
  onboarding,
  client,
  general,
  prospect,
  none: {}
}

export default {
  getError: (errorKey, type = 'none') => errors[type][errorKey] || defaultError
}



// WEBPACK FOOTER //
// ./src/components/ErrorPage/errorDisplayHandler.js